import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "8",
  cy: "8",
  r: "8",
  fill: "#F3A700"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M11.664 3.996H9.602v8.005h2.062V3.996ZM6.861 9.374A2.552 2.552 0 0 0 9.183 6.61a2.552 2.552 0 0 0-2.322 2.765ZM6.453 3.996H4.391v8.005h2.062V3.996Z",
  fill: "#FFE2A3"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }